module.exports = __webpack_public_path__ + "media/images/shared/icon_twitter-a4d59225fbd59eeb3c449e135af1365e.png";